import { createSelector } from 'reselect'
import { Guards } from 'interfaces/guards'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { creditAccountsGuard } from 'guards/creditGuards'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { creditAccountsSelector, isPIIVerifiedSelector } from 'selectors/creditSelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import CreditAccountsDetailsModule, {
  CreditAccountsDetailsModuleStateProps,
  CreditAccountsDetailsModuleOwnProps,
} from 'components/features/pfm/CreditAccountsDetailsModule/CreditAccountsDetailsModule'
import { isMobileSelector } from 'selectors/viewportSelectors'

const createMapStateToProps = () =>
  createSelector(
    creditAccountsSelector,
    isPIIVerifiedSelector,
    isMobileSelector,
    (accounts, isPIIVerified, isMobile): CreditAccountsDetailsModuleStateProps => {
      if (!accounts) {
        throw createForgottenGuardError('CreditAccountsDetailsModuleContainer', 'creditAccountsGuard')
      }

      return {
        isMobile,
        rows: getItemsFromCollection(accounts),
        showLinkagePlaceholder: !isPIIVerified,
      }
    }
  )

const guards: Guards<CreditAccountsDetailsModuleOwnProps> = [
  creditAccountsGuard,
]

const CreditAccountsDetailsModuleContainer = connectShadedLoadable<
  CreditAccountsDetailsModuleStateProps,
  {},
  CreditAccountsDetailsModuleOwnProps
>(createMapStateToProps, undefined, guards)(CreditAccountsDetailsModule)
export default CreditAccountsDetailsModuleContainer
